import { lazy, Suspense } from 'react'

const PhotoManagerUploadDialog = lazy(() => import('./PhotoManagerUploadDialog'))

export default function LazyPhotoManagerUploadDialog({ open, ...props }) {
  if (!open) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <PhotoManagerUploadDialog open={open} {...props} />
    </Suspense>
  )
}
